<template>
  <div class="page-container">
    <div class="header">
      <span class="page-title">藥洗紀錄</span>
      <a-select v-if="user.role==='superAdmin'" v-model:value="selectedCompanyID" placeholder="" style="width: 200px"
                @change="handleChange">
        <a-select-option
            v-for="item in companies"
            :key="item.id"
            :value="item.id">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </div>
    <div class="card-content">
      <div class="search-bar">
        <a-input v-model:value="searchText" type="text" style="width: 200px" placeholder="設備"/>
        <a-button @click="filterData">搜尋</a-button>
        <a-button @click="navigateToAdd" type="primary" class="btn-add">+ 新增</a-button>
      </div>


      <a-table :columns="columns"
               :data-source="filteredData"
               rowKey="id"
               :custom-row="customRow"
               :rowClassName="() => (`row`)">

        <template v-slot:bodyCell="props">
          <div v-if="props.column.key === 'action'">
            <span>
              <a-dropdown :trigger="['click']">
                <a-button class="ant-dropdown-link btn-action" @click.prevent>
                  <img src="@/assets/ic_more.svg" class="icon"/>
                </a-button>
                <template #overlay>
                  <a-menu>
                    <a-menu-item key="0">
                      <a @click="performAction(props.record, 'edit')">編輯</a>
                    </a-menu-item><a-menu-divider/>
                    <a-menu-item key="1">
                      <a @click="performAction(props.record, 'delete')" style="color: red">刪除</a>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </span>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import {message, Modal} from "ant-design-vue";
import dayjs from "dayjs";

export default {
  name: "AccountPage",
  inject: ['getUserData', 'getCompanyData', 'getSelectedCompany', 'setSelectedCompany'],
  data() {
    return {
      items: [],
      searchText: "",
      filterStatus: "",

      selectedCompanyID: null,

      columns: [
        {
          title: '日期',
          customRender: ({record}) => {
            return `${dayjs(record.time).format("YYYY-MM-DD")}`;
          },
        },
        {
          title: '時間',
          customRender: ({record}) => {
            return `${dayjs(record.time).format("HH:mm")}`;
          },
        },
        {
          title: '實施人員',
          customRender: ({record}) => {
            return `${record.user.last_name}${record.user.first_name}`
          }
        },
        {
          title: '設備',
          customRender: ({record}) => {
            return `${record.device_name}`
          }
        },
        {
          title: '操作',
          key: 'action'
        },
      ],
    };
  },
  computed: {
    user() {
      return this.getUserData();
    },
    filteredData() {
      let data = this.items;

      if (this.searchText) {
        data = data.filter((item) =>
            item.device_name.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }

      if (this.filterStatus) {

        if (this.filterStatus === '') {
          data = this.items;
        } else {
          const isActive = this.filterStatus === "true";
          data = this.items.filter((item) => item.is_active === isActive);
        }
      }

      return data;
    },
    companies() {
      return this.getCompanyData()
    }
  },
  mounted() {
    this.selectedCompanyID = this.getSelectedCompany().id;
    this.fetchData();
  },
  methods: {
    fetchData() {

      let queryParams = [];
      if (this.user.role==='superAdmin') {
        queryParams.push(`organization_id=${this.selectedCompanyID}`)
      }

      const token = localStorage.getItem('token');
      this.$axios.get(`/api/cleaning-logs?${queryParams.join('&')}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        this.items = response.data.data;
        console.log(response.data.data);
      }).catch(error => {
        console.error(error.status);
        if (error.status === 401) {
          this.$router.push('/login');
        }
      });
    },
    filterData() {

    },
    navigateToAdd() {
      this.$router.push('/cleaning-log/add');
    },
    handleChange(value) {
      const selectedItem = this.companies.find(item => item.id === value);
      this.setSelectedCompany(selectedItem);
      this.fetchData();
    },
    customRow(item) {
      return {
        onClick: (e) => {
          if (['img', 'button'].includes(e.target.tagName.toLowerCase())) return;
          this.$router.push({name: 'CleaningLogView', params: {id: item.id}})
          e.stopPropagation()
        }
      }
    },
    performAction(item, action) {
      console.log(`執行 ${action} 操作, 用戶：${item}`);

      const token = localStorage.getItem('token');
      const isActive = item.is_active;

      switch (action) {
        case 'edit':
          this.$router.push({name: 'CleaningLogEdit', params: {id: item.id}});
          break;
        case 'suspend':

          this.$axios.patch(`/api/users/${item.id}`, {
            is_active: !isActive
          }, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }).then(response => {
            console.log(response.data.data);
            this.fetchData();
            message.success(`已將帳號${isActive ? "停權" : "復權"}`);
          }).catch(error => {
            console.error(error.status);
            if (error.status === 401) {
              this.$router.push('/login');
            }
          });
          break;
        case 'delete':

          Modal.confirm({
            title: '刪除藥洗記錄',
            content: '確認刪除此筆藥洗記錄嗎？',
            okText: '刪除',
            okType: 'primary',
            okButtonProps: {
              danger: true
            },
            cancelText: '取消',
            onOk: () => {

              this.$axios.delete(`/api/cleaning-logs/${item.id}`, {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }).then(response => {
                console.log(response.data.data);
                this.fetchData();
                message.success('已將藥洗記錄刪除');
              }).catch(error => {
                console.error(error.status);
                if (error.status === 401) {
                  this.$router.push('/login');
                }
              });
            },
          });

          break;
      }
    }
  },
};
</script>

<style scoped>
.container {
  padding: 2em;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-content {
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
  padding: 20px;
}

.search-bar {
  margin-bottom: 1em;
  display: flex;
  gap: 10px;
}

.btn-add {
  margin-left: auto;
}

.row {
  cursor: pointer !important;
  transition: background-color 0.3s;
}

.row:hover {
  background-color: #f5f5f5;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-action {
  border-radius: 8px;
  border: none;
  background-color: #f5f5fa;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
